import { Component, HostListener, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { AppService, CoreProxyService, CoreTypes, SharedCommonService, CLIENT_LOGO_BAR } from 'common-cloudstudio';
import { GearProxyService, GearAppService, GearTypes } from 'common-gear';
import { Subscription } from 'rxjs';
import { MenuService } from '../services/menu.service';

export class SidebarItem extends CoreTypes.MenuHierarchy {
  url: string;
  index: number;
  children: SidebarItem[];
}

@Component({
  selector: 'sidebar-cmp',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SidebarComponent implements OnInit, OnDestroy {
  collapses: boolean[] = [];
  collapseIndex = 0;
  _reports: CoreTypes.ReportDefinition[];
  _subscriptions: Subscription[] = [];
  _clientLogoBar = CLIENT_LOGO_BAR;
  sidebarItems: SidebarItem[] = [];
  itemIndex = 0;

  constructor(
    public _appService: AppService,
    private _router: Router,
    private _gearProxyService: GearProxyService,
    public _gearAppService: GearAppService,
    private _sharedCommonService: SharedCommonService,
    private _coreProxyService: CoreProxyService,
    private menuService: MenuService,
  ) { }

  ngOnInit() {
    this.menuService.menuItems.subscribe(items => {
      if (!items?.length) { return; }
      this.mapMenu();
      this.setActiveItem();
    });
    this._subscriptions.push(this._appService.onStartingSettings.subscribe(settings => {
      if(!settings) { return; }
      (settings.instanceImages && settings.instanceImages.BarLogo) ? this._clientLogoBar = settings.instanceImages.BarLogo : this._clientLogoBar = settings.startingSettings.Images.BarLogo;
    }));

    this._router.events.subscribe(async (event: Event) => {
      if (!(event instanceof NavigationEnd)) { return; }
      setTimeout(() => {
        if (!document.querySelectorAll('#sidebar .collapse .nav-link.active').length) {
          this.collapses.forEach((item, k) => { this.collapses[k] = true; });
        }
        this.setActiveItem();
        if (window.innerWidth < 992) {
          // Hide sidebar on mobile when section change
          document.getElementById('sidebar').classList.remove('open');
          document.getElementsByTagName('body')[0].classList.remove('sidebar-open');
        }
      }, 10);
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  setActiveItem() {
    setTimeout(() => {
      document.querySelectorAll('#sidebar .collapse').forEach(collapse => {
        const id = (+collapse.id.replace('collapses', ''));
        if (!this.collapses[id]) { this.collapses[id] = true; }
        if (collapse.querySelector('.nav-link.active') && this.collapses[id] === true) {
          this.collapse(id);
        }
      });
    }, 100);
  }

  collapse(index: number) {
    this.collapses[index] = !this.collapses[index];
    this.collapses.forEach((_, k) => {
      if (k !== index) { this.collapses[k] = true;}
    });
  }

  mapMenu(items?: SidebarItem[]) {
    const menuItems = this.menuService.menuItems.value;
    let environmentDev = this._appService.getBaseURL().includes("-dev") || this._appService.getBaseURL().includes("-staging");

    if (!items) {
      this.sidebarItems = [];

      // Get top level items
      menuItems.filter(item =>
        menuItems.findIndex(s =>
          s.SidebarSettings?.ChildrenIds?.indexOf(item.MenuID) > -1
        ) < 0
      ).forEach(item => {
        if (item.SidebarSettings && item.SidebarSettings?.Hidden) { return;}
        this.sidebarItems.push({...new SidebarItem(), ...item, MenuID: item.MenuID, index: this.itemIndex});
        this.itemIndex++;
      });
      // Make the tree menu
      this.mapMenu(this.sidebarItems);
      return;
    }
    items.forEach((parent) => {
      parent.children = [];
      menuItems.filter(f => parent.SidebarSettings?.ChildrenIds?.indexOf(f.MenuID) > -1).forEach((child, i) => {
        if ((child.SidebarSettings && child.SidebarSettings?.Hidden) || 
        (child.MenuID === GearTypes.GearMenuHierarchyItem.GlobalDashboards) ||
        (!environmentDev && child.MenuID === GearTypes.GearMenuHierarchyItem.AlarmWithHeatMap)) { return; }
        parent.children.push({
          ...new SidebarItem(),
          ...child,
          MenuID: child.MenuID,
          index: this.itemIndex,
          url: this.menuService.getItemUrl(child.MenuID, parent.MenuID)
        });

        this.itemIndex++;
      });
      this.mapMenu(parent.children);
    });
  }
}
